<script lang="ts">
  import globalStore from '../../stores/global.svelte'
  import LaunchpadNavBottom from './LaunchpadNavBottom.svelte'

  let shortCode = globalStore.currentAccount.short_code
</script>

<div class="LaunchpadAutoResponse">

  <div class="flex-row">
    <div class="cell-3 cell-left">
      <h2>Auto Response</h2>
      <p>
        Offer value immediately with a custom auto-response
        when a customer opts in.
      </p>

      <hr class="mb-0">
      <h3>How it works</h3>
      <p class="mb-5">
        An auto repose is an automated text message that new contacts
        receive once they opt in to your list. This happens when they
        text your keyword to {shortCode}.
      </p>

      <LaunchpadNavBottom></LaunchpadNavBottom>
    </div>

    <div class="cell-1 cell-right">
      <p>
        You can easily customize your Auto Responses from
        the Keywords page.
      </p>
      <div class="white-circle">
        <div class="white-circle-content">
          <span class="icon icon--launchpad-autoreponse"></span>
        </div>
      </div>
      <p class="mt-1">
        <a href="/keywords" class="btn btn-green btn-rounded">Go to Keywords</a>
      </p>
    </div>
  </div>

</div>
